import { render } from "./ManageRegistRate.vue?vue&type=template&id=4df4c30a"
import script from "./ManageRegistRate.vue?vue&type=script&lang=js"
export * from "./ManageRegistRate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__